import { useSeo } from "@/lib/seo";

const Section = ({ title, children }) => (
  <div className="mt-8">
    <h2 className="font-display text-xl font-semibold text-white">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-300">{children}</div>
  </div>
);

export default function Privacy() {
  useSeo({
    title: "Privacy Policy",
    description:
      "Privacy Policy for the HILDRETH TECHNOLOGIES LLC company website, covering contact form information, server logs, cookies, and data requests.",
    path: "/privacy-policy",
  });

  return (
    <div className="mx-auto max-w-3xl px-5 py-20 sm:px-8">
      <p className="text-sm font-semibold uppercase tracking-wider text-sky-400">Legal</p>
      <h1 className="mt-3 font-display text-4xl font-semibold tracking-tight text-white">
        Privacy Policy
      </h1>
      <p className="mt-4 text-sm text-slate-500">Effective date: July 2026</p>
      <p className="mt-6 text-sm leading-relaxed text-slate-300">
        This Privacy Policy explains how HILDRETH TECHNOLOGIES LLC (“we,” “us,” or
        “the company”) handles information collected through this company website
        at the domain where it is hosted. It applies to this marketing website
        only. Each product operated by the company maintains its own separate
        privacy policy, which is available on that product's own website.
      </p>

      <Section title="Information submitted through the contact form">
        <p>
          When you use our contact form, we collect the information you provide,
          which may include your name, email address, company or organization,
          reason for contacting, product of interest, and the content of your
          message. We use this information only to respond to and manage your
          inquiry.
        </p>
      </Section>

      <Section title="Basic server logs">
        <p>
          Like most websites, our hosting infrastructure may automatically record
          basic technical information such as IP address, browser type, and pages
          requested. This information is used to operate, secure, and troubleshoot
          the website.
        </p>
      </Section>

      <Section title="Cookies and analytics">
        <p>
          This website uses only the cookies and limited analytics that are
          necessary to operate the site and understand general, aggregate usage.
          We do not use this website to build advertising profiles or to sell your
          information.
        </p>
      </Section>

      <Section title="Google Analytics">
        <p>
          HILDRETH TECHNOLOGIES LLC uses Google Analytics to understand how
          visitors find and use this website. Google Analytics may collect
          information such as pages visited, referral sources, approximate
          geographic region, device and browser category, interactions with
          website links, and time spent on the site. Contact-form names, email
          addresses, and message contents are not intentionally sent to Google
          Analytics. This information is used to evaluate website traffic and
          improve the website.
        </p>
        <p>
          Visitors may use their browser settings, cookie controls, or Google's
          available opt-out tools (such as the Google Analytics Opt-out Browser
          Add-on) to limit analytics collection.
        </p>
      </Section>

      <Section title="How inquiries are used">
        <p>
          Inquiries submitted through the contact form are used to respond to your
          request, route it to the appropriate area (such as general questions,
          support, partnerships, or media), and maintain a record of the
          communication. We do not use contact-form information for unrelated
          marketing.
        </p>
      </Section>

      <Section title="We do not sell your information">
        <p>
          HILDRETH TECHNOLOGIES LLC does not sell, rent, or trade the personal
          information you submit through this website.
        </p>
      </Section>

      <Section title="Reasonable security practices">
        <p>
          We use reasonable administrative and technical measures intended to
          protect the information submitted through this website. No method of
          transmission or storage is completely secure, and we cannot guarantee
          absolute security.
        </p>
      </Section>

      <Section title="Requesting correction or deletion">
        <p>
          You may request that we correct or delete the information you submitted
          through the contact form by emailing us at{" "}
          <a href="mailto:support@hildrethtechnology.com" className="font-medium text-sky-300 hover:text-sky-200">
            support@hildrethtechnology.com
          </a>
          . We will make reasonable efforts to honor valid requests.
        </p>
      </Section>

      <Section title="Product privacy policies">
        <p>
          Products such as MedPolicyRef, RouteCast, Emergent VPN, Endoscopy Nurse
          Pro, Patriot News US, and TikHooks2 are governed by their own privacy
          policies, which are available on each product's respective website.
        </p>
      </Section>

      <Section title="Contact">
        <p>
          Questions about this Privacy Policy may be directed to{" "}
          <a href="mailto:support@hildrethtechnology.com" className="font-medium text-sky-300 hover:text-sky-200">
            support@hildrethtechnology.com
          </a>
          .
        </p>
      </Section>
    </div>
  );
}
